<h1 mat-dialog-title class="p-2 text-center">Nouvelle sonde</h1>
<div class="p-3">
    <div class="col">
        <div class="row">
            <mat-form-field class="col">
                <mat-label>Matériel</mat-label>
                <mat-select placeholder="Matériel" [(ngModel)]="model.Type" required>
                    <mat-option *ngFor="let o of SondeTypeList; let i = index" [value]="i + 1">
                        <span>{{o}}</span>
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="row">
            <mat-form-field class="col">
                <mat-label>Référence</mat-label>
                <input matInput placeholder="Référence" [(ngModel)]="model.Reference" [disabled]="!IsCreation">
            </mat-form-field>
        </div>
        <div class="row">
            <mat-form-field class="col">
                <mat-label>Facteur de correction</mat-label>
                <input matInput placeholder="Facteur de correction" [(ngModel)]="model.FacteurCorrection" >
            </mat-form-field>
        </div>
        <div class="row">
            <button class="col mx-3 my-2" appPreventDoubleClick [throttleTime]="200" mat-raised-button color="accent" (throttledClick)="onCancel()">
                Annuler<mat-icon>undo</mat-icon>
            </button>
        </div>
        <div class="row">
            <button class="col mx-3 my-1" appPreventDoubleClick [throttleTime]="200" mat-raised-button color="primary" (throttledClick)="onConfirm()" [disabled]="!CanAddSonde()">
                Sauvegarder<mat-icon>save</mat-icon>
            </button>
        </div>
    </div>
</div>